export default __webpack_public_path__ + "static/media/liiv-slider-tabletki.035398bb.jpg";